

// import moment from 'moment'
// import React from 'react'
// import jsonpath from 'jsonpath'

// const DailyInitialFlowManagement_PROCESS = ({ data, company,test }) => {
//     const checksheetdata = test.filter(one => 
//         one.InspectionType === 'IFM - Process - Fbd' &&
//         (one.DateTime.split('T')[0] === data.DateTime.split('T')[0]) &&
//         one.Item === data.Item &&
//         one.customFields.find(field => 
//           field.FieldName === 'Shift' && 
//           field.Value[0] === extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value')[0]
//         )
//       );


//   console.log(data, "sdcssdkc",test,checksheetdata)
//   function extractData(json, path) {
//     const result = jsonpath.query(json, path);
//     return result;
//   }
//   return (
//     <div>
//       <table id={''} className="table table-sm table-bordered table-hover small table-striped " style={{ padding: 0 }}>
//         <thead className='small text-center border'>

//           <tr className='text-center align-self-center '>
//             <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Part Name :</th>
//             <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{data.Item}</th>

//             <th style={{ verticalAlign: 'middle' }} className='fs-6' rowSpan={4} colSpan={(checksheetdata.length) }> DAILY INITIAL FLOW MANAGEMENT CONTROL ITEMS MONITORING CHECKSHEET ( PROCESS )</th>

//             {/* <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={3}>Date :</th> */}


//           </tr>  <tr className='text-center align-self-center '>
//             <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Part No :</th>
//             <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{data.Item}</th>




//           </tr>
//           <tr className='text-center align-self-center '>
//             <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Model :</th>
//             <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{extractData(data, '$..customFields[?(@.FieldName=="Model")].Value')}</th>

//           </tr>
//           <tr className='text-center align-self-center '>
//             <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Vendor :</th>
//             <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{extractData(data, '$..customFields[?(@.FieldName=="Vendor")].Value')}</th>
//           </tr>
//           <tr className='text-center align-self-center '>
//             <th style={{ verticalAlign: 'middle' }} rowSpan={4} >S.No</th>
//             <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Process</th>
//             <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Process Parameter</th>
//             <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Spec</th>
//             {/* <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Content</th>
//             <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Process Capability Applicable (Yes /No)</th> */}
//             <th style={{ verticalAlign: 'middle' }} rowSpan={4} >CHECKING METHODS </th>
//             <th style={{ verticalAlign: 'middle' }} rowSpan={4} >Normal Frequency </th>
//             <th style={{ verticalAlign: 'middle' }} rowSpan={4} >IFM Frequency </th>
//             <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={ checksheetdata.length == 1 ? checksheetdata.length +1 :1}>Result</th>


//           </tr>

//           <tr className='text-center align-self-center '>


//           <th style={{ verticalAlign: 'middle' }} rowSpan={1} >Date </th>
//           <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={checksheetdata.length}> {moment(data.DateTime).format('DD-MM-YYYY')}</th>


//           </tr>
//           <tr className='text-center align-self-center '>



//           <th style={{ verticalAlign: 'middle' }} rowSpan={1} >Shift</th>
//           <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={checksheetdata.length}>{ extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value') }</th>


//           </tr><tr className='text-center align-self-center '>



//            <th style={{ verticalAlign: 'middle' }} rowSpan={1} >Time </th>

//             {(checksheetdata).map((_, index) => <th style={{ verticalAlign: 'middle' }} rowSpan={1} >{ moment(_.DateTime).format('h:mm a')}</th>)}
//            </tr>

//         </thead>

//         <tbody>

//           {data.Checksheet.map((one, index) => <tr >


//             <th style={{ fontWeight: '400' }} className="text-center">{one.SNO}</th>
//             <th style={{ fontWeight: '400' }} className="text-center">{one.Process
//             }</th>
//             <th style={{ fontWeight: '400' }} className="text-center">{one.Process_Parameter
//             }</th>
//             <th className="text-center" style={{ fontWeight: '400' }}>{one.Spec
//             }</th>
//             {/* <th className="text-center" style={{ fontWeight: '400' }}>{one.Content}</th>
//             <th className="text-center" style={{ fontWeight: '400' }}></th> */}
//             <th className="text-center" style={{ fontWeight: '400' }}>{one.Checking_Method}</th>


//             <th className="text-center" style={{ fontWeight: '400' }}>{one.Normal_Freq}</th>
//             <th className="text-center" style={{ fontWeight: '400' }}>{one.IFM_Freq}</th>
//             <th className="text-center" style={{ fontWeight: '400' }}></th>

//             {checksheetdata.length > 0 && checksheetdata.map((_, idx) => <th className="text-center" style={{ verticalAlign: 'middle' }} rowSpan={1} >{_.Checksheet[index] && _.Checksheet[index].Data[0] ? _.Checksheet[index].Data[0].Result : '-'}</th>)}


//           </tr>)}



//         </tbody>
//         <tfoot className='small text-center border'>
//           <tr className='text-center align-self-center '>
//             <td style={{ verticalAlign: 'middle' }} className='text-start ' colSpan={8}>Note - Making is Required on first 5000 Parts or for first 3 months whichever is earlier</td>
//             <td style={{ verticalAlign: 'middle' }} colSpan={checksheetdata.length}></td>


//           </tr>
//           <tr className='text-center align-self-center '>
//             <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={8}>CHECKED BY</td>
//             <td style={{ verticalAlign: 'middle' }} colSpan={checksheetdata.length}></td>


//           </tr> <tr className='text-center align-self-center '>
//             <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={8}>VERIFIED BY</td>
//             <td style={{ verticalAlign: 'middle' }} colSpan={checksheetdata.length}></td>


//           </tr> <tr className='text-center align-self-center '>
//             <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={8}>APPROVED</td>
//             <td style={{ verticalAlign: 'middle' }} colSpan={checksheetdata.length}></td>


//           </tr> <tr className='text-center align-self-center '>
//             <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={8}>REMARKS</td>
//             <td style={{ verticalAlign: 'middle' }} colSpan={checksheetdata.length}></td>


//           </tr>

//         </tfoot>

//       </table>

//     </div>
//   )
// }

// export default DailyInitialFlowManagement_PROCESS
// import moment from 'moment'
// import React from 'react'
// import jsonpath from 'jsonpath'
// import React, { useRef } from 'react';
// const DailyInitialFlowManagement_PROCESS = ({ data, company, test }) => {

//     const demoFromHTML = async () => {
//         const source = customerRef.current;

//         // Wait for all images in the source element to be loaded
//         const loadImages = () => {
//             const images = source.getElementsByTagName('img');
//             const promises = Array.from(images).map((img) => {
//                 return new Promise((resolve) => {
//                     if (img.complete) {
//                         resolve();
//                     } else {
//                         img.onload = resolve;
//                         img.onerror = resolve; // Resolve in case of an error as well
//                     }
//                 });
//             });
//             return Promise.all(promises);
//         };

//         // Wait for images to load
//         await loadImages();

//         const table = source.querySelector('table'); // Target the table element
//         const rows = Array.from(table.querySelectorAll('tr')); // Get all rows of the table

//         const maxRowsPerPage = 25; // Set 25 rows per page
//         const totalRows = rows.length;
//         const numPages = Math.ceil(totalRows / maxRowsPerPage); // Calculate the number of pages needed

//         const pdf = new jsPDF('landscape', 'pt', 'a4');
//         const pdfWidth = pdf.internal.pageSize.getWidth();
//         const pdfHeight = pdf.internal.pageSize.getHeight();

//         const margin = 20;
//         const marginWidth = margin;
//         const marginHeight = margin;

//         const availableWidth = pdfWidth - 2 * marginWidth;
//         const availableHeight = pdfHeight - 2 * marginHeight;

//         for (let page = 0; page < numPages; page++) {
//             const canvas = await html2canvas(source, { scale: 2 });

//             // Get only the rows for the current page (25 rows per page)
//             const startRow = page * maxRowsPerPage;
//             const endRow = Math.min((page + 1) * maxRowsPerPage, totalRows);
//             const currentRows = rows.slice(startRow, endRow);

//             // Temporarily hide rows not belonging to the current page
//             rows.forEach((row, index) => {
//                 row.style.display = index >= startRow && index < endRow ? '' : 'none';
//             });

//             // Re-render the canvas for the current page's content
//             const canvasForPage = await html2canvas(source, { scale: 2 });
//             const imgData = canvasForPage.toDataURL('image/jpeg', 0.7);

//             const imgHeight = (canvasForPage.height * availableWidth) / canvasForPage.width;
//             const position = marginHeight;

//             // Add content to the PDF for the current page
//             pdf.addImage(
//                 imgData,
//                 'JPEG',
//                 marginWidth,
//                 position,
//                 availableWidth,
//                 imgHeight > availableHeight ? availableHeight : imgHeight
//             );

//             if (page < numPages - 1) {
//                 pdf.addPage(); // Add a new page if it's not the last one
//             }
//         }

//         // Restore all rows to be visible after generating the PDF
//         rows.forEach(row => (row.style.display = ''));

//         pdf.save(`${reportData.InspectionType}_${new Date(reportData.DateTime).toLocaleString()}.pdf`);
//     };




//     const refs = useRef([]);
//     const checksheetdata = test.filter(one =>
//         one.InspectionType === 'IFM - Process - Fbd' &&
//         (one.DateTime.split('T')[0] === data.DateTime.split('T')[0]) &&
//         one.Item === data.Item &&
//         one.customFields.find(field =>
//             field.FieldName === 'Shift' &&
//             field.Value[0] === extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value')[0]
//         )
//     );

//     console.log(data, "sdcssdkc", test, checksheetdata)

//     function extractData(json, path) {
//         const result = jsonpath.query(json, path);
//         return result;
//     }

//     // Function to split data into chunks of 10
//     const chunkArray = (array, size) => {
//         const result = [];
//         for (let i = 0; i < array.length; i += size) {
//             result.push(array.slice(i, i + size));
//         }
//         return result;
//     };

//     // Split the checksheetdata into chunks of 10
//     const chunkedChecksheetData = chunkArray(checksheetdata, 10);

//     // Table rendering function
//     const renderTable = (tableData, tableIndex) => ( <>
//                 <button className="btn-sm btn-primary" onClick={demoFromHTML}>Download PDF</button>

//         <table id={''}    ref={(el) => refs.current[tableIndex] = el}  className="table table-sm table-bordered table-hover small table-striped " style={{ padding: 0 }} key={tableIndex}>
//             <thead className='small text-center border'>
//                 <tr className='text-center align-self-center '>
//                     <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Part Name :</th>
//                     <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{data.Item}</th>
//                     <th style={{ verticalAlign: 'middle' }} className='fs-6' rowSpan={4} colSpan={tableData.length}> DAILY INITIAL FLOW MANAGEMENT CONTROL ITEMS MONITORING CHECKSHEET ( PROCESS )</th>
//                 </tr>
//                 <tr className='text-center align-self-center '>
//                     <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Part No :</th>
//                     <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{data.Item}</th>
//                 </tr>
//                 <tr className='text-center align-self-center '>
//                     <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Model :</th>
//                     <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{extractData(data, '$..customFields[?(@.FieldName=="Model")].Value')}</th>
//                 </tr>
//                 <tr className='text-center align-self-center '>
//                     <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Vendor :</th>
//                     <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{extractData(data, '$..customFields[?(@.FieldName=="Vendor")].Value')}</th>
//                 </tr>
//                 <tr className='text-center align-self-center '>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={4}>S.No</th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={4}>Process</th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={4}>Process Parameter</th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={4}>Spec</th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={4}>CHECKING METHODS </th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={4}>Normal Frequency </th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={4}>IFM Frequency </th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={tableData.length == 1 ? tableData.length + 1 : 1}>Result</th>
//                 </tr>
//                 <tr className='text-center align-self-center '>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={1}>Date </th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={tableData.length}> {moment(data.DateTime).format('DD-MM-YYYY')}</th>
//                 </tr>
//                 <tr className='text-center align-self-center '>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={1}>Shift</th>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={tableData.length}>{extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value')}</th>
//                 </tr>
//                 <tr className='text-center align-self-center '>
//                     <th style={{ verticalAlign: 'middle' }} rowSpan={1}>Time </th>
//                     {tableData.map((_, index) => <th style={{ verticalAlign: 'middle' }} rowSpan={1} key={index}>{moment(_.DateTime).format('h:mm a')}</th>)}
//                 </tr>
//             </thead>
//             <tbody>
//                 {data.Checksheet.map((one, index) => (
//                     <tr key={index}>
//                         <th style={{ fontWeight: '400' }} className="text-center">{one.SNO}</th>
//                         <th style={{ fontWeight: '400' }} className="text-center">{one.Process}</th>
//                         <th style={{ fontWeight: '400' }} className="text-center">{one.Process_Parameter}</th>
//                         <th className="text-center" style={{ fontWeight: '400' }}>{one.Spec}</th>
//                         <th className="text-center" style={{ fontWeight: '400' }}>{one.Checking_Method}</th>
//                         <th className="text-center" style={{ fontWeight: '400' }}>{one.Normal_Freq}</th>
//                         <th className="text-center" style={{ fontWeight: '400' }}>{one.IFM_Freq}</th>
//                         <th className="text-center" style={{ fontWeight: '400' }}></th>
//                         {tableData.map((_, idx) => (
//                             <th key={idx} className="text-center" style={{ verticalAlign: 'middle' }} rowSpan={1}>{_.Checksheet[index] && _.Checksheet[index].Data[0] ? _.Checksheet[index].Data[0].Result : '-'}</th>
//                         ))}
//                     </tr>
//                 ))}
//             </tbody>
//         </table>
//         </>
//     );

//     return (
//         <div>
//             {/* Render tables dynamically based on chunks */}
//             {chunkedChecksheetData.map((tableData, index) => (
//                 renderTable(tableData, index)
//             ))}
//         </div>
//     )
// }

// export default DailyInitialFlowManagement_PROCESS;

import moment from 'moment';
import React, { useRef } from 'react';
import jsonpath from 'jsonpath';
import html2canvas from 'html2canvas'; // Ensure this is installed
import jsPDF from 'jspdf'; // Ensure this is installed
import { Footer } from 'antd/lib/layout/layout';

const DailyInitialFlowManagement_PROCESS = ({ data, company, test }) => {
    const refs = useRef([]); // Array to hold refs for each table

    const downloadPdf = (tableData) => {
        const doc = new jsPDF('landscape'); // 'portrait' or 'landscape'
        const title = `Daily Initial Flow Management`;

        // Title and Date
        // doc.text(title, 14, 22); // Uncomment if you want to add a title
        // doc.text(`DATE: ${moment(data.DateTime).format('DD-MM-YYYY')}`, 14, 32); // Uncomment if you want to add the date

        // Create table header rows as defined in the <thead>
        const tableHeaders = [
            [
                { content: `Part Name: `, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },

                { content: ` ${data.Item}`, colSpan: 4, rowSpan: 1, styles: { halign: 'left' ,cellPadding:1} },
                { content: "DAILY INITIAL FLOW MANAGEMENT CONTROL ITEMS MONITORING CHECKSHEET ( PROCESS )", colSpan: tableData.length == 0 ? 1 : tableData.length, rowSpan: 4, styles: { halign: 'center', valign: 'middle',cellPadding:1 } },


            ],

            [
                { content: `Part No:`, colSpan: 4, rowSpan: 1, styles: { halign: 'left' ,cellPadding:1} },
                { content: `${data.ItemNumber}`, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },

            ],
            [
                { content: `Model: `, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },
                { content: ` ${extractData(data, '$..customFields[?(@.FieldName=="Model")].Value')}`, colSpan: 4, rowSpan: 1, styles: { halign: 'left',cellPadding:1 } },

            ],
            [
                { content: `Vendor: `, colSpan: 4, rowSpan: 1, styles: { halign: 'left' ,cellPadding:1} },

                { content: `${extractData(data, '$..customFields[?(@.FieldName=="Vendor")].Value')}`, colSpan: 4, rowSpan: 1, styles: { halign: 'left' ,cellPadding:1} },
            ],
            [
                { content: 'S.No', rowSpan: 4, colSpan: 1, styles: { halign: 'center' ,cellPadding:1} },
                { content: 'Process', rowSpan: 4, colSpan: 1, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
                { content: 'Process Parameter', rowSpan: 4, colSpan: 1, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },

                { content: 'Spec', rowSpan: 4, colSpan: 1, styles: { halign: 'center', cellWidth: 20,cellPadding:1 } },
                { content: 'Checking Methods', rowSpan: 4, colSpan: 1, styles: { halign: 'center', cellWidth: 20 ,cellPadding:1} },
                { content: 'Normal Frequency', rowSpan: 4, colSpan: 1, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
                { content: 'IFM Frequency', rowSpan: 4, colSpan: 1, styles: { halign: 'center', cellWidth: 20 ,cellPadding:1} },
                { content: 'Result', colSpan: tableData.length + 1, rowSpan: 1, styles: { halign: 'center' ,cellPadding:1} }
            ],
            [{ content: `Date`, colSpan: 1, rowSpan: 1, styles: { halign: 'left' ,cellPadding:1} },
            { content: moment(data.DateTime).format('DD-MM-YYYY'), colSpan: tableData.length, rowSpan: 1, styles: { halign: 'center' ,cellPadding:1} },

            ],
            [
                { content: `Shift`, colSpan: 1, rowSpan: 1, styles: { halign: 'left' ,cellPadding:1} },
                { content: extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value'), colSpan: tableData.length, rowSpan: 1, styles: { halign: 'center',cellPadding:1 } }


            ],

            [
                { content: `Time`, colSpan: 1, rowSpan: 1, styles: { halign: 'left' ,cellPadding:1} },
                ...tableData.map((_, index) => ({ content: moment(_.DateTime).format('HH:mm'), rowSpan: 1, colSpan: 1, styles: { halign: 'center' ,cellPadding:1} }))
            ],

        ];
        const tableFooter =[
            [ { content: 'Note - Making is Required on first 5000 Parts or for first 3 months whichever is earlier	', rowSpan: 1, colSpan: 3, styles: { halign: 'center' ,cellPadding:1} },
             { content: '', rowSpan: 1, colSpan: 7+ tableData.length, styles: { halign: 'center' ,cellPadding:1} },
            ],
            [
               { content: 'CHECKED BY', rowSpan: 1, colSpan: 3, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
             { content: `${extractData(data, '$..customFields[?(@.FieldName=="Checked By")].Value')}`, rowSpan: 1, colSpan: tableData.length+7, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
         
            ],
            [
              { content: 'VERIFIED BY', rowSpan: 1, colSpan: 3, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
            { content: '', rowSpan: 1, colSpan: tableData.length+7, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
        
           ],
           [
            { content: 'APPROVED', rowSpan: 1, colSpan: 3, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
          { content: '', rowSpan: 1, colSpan: tableData.length+7, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
      
         ],
         [
          { content: 'REMARKS', rowSpan: 1, colSpan: 3, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
        { content: `${getString(tableData)}`, rowSpan: 1, colSpan: tableData.length+7, styles: { halign: 'center', cellWidth: 25 ,cellPadding:1} },
      
       ]
            ]
        // AutoTable settings with border styles
        doc.autoTable({
            head: tableHeaders,
            body: data.Checksheet.map((one) => [
                one.SNO,
                one.Process,
                one.Process_Parameter,
                one.Spec,
                one.Checking_Method,
                one.Normal_Freq,
                one.IFM_Freq,
                "", // Process Capability Applicable
                ...tableData.map((_, index) => (_.Checksheet[index] &&   _.Checksheet[index].StandardType =='Dimension' ? _.Checksheet[index].Data[0] && (_.Checksheet[index].Data[0].Result + ' / ' + _.Checksheet[index].Data[0].Observed_Value ): _.Checksheet[index].Data[0]   && _.Checksheet[index].Data[0] ? _.Checksheet[index].Data[0].Result : '-')),
            ]),
            Footer:tableFooter,
            startY: 20,
            theme: 'striped',
            styles: {
                fontSize: 8,
                cellPadding: 2,
                lineWidth: 0.1,
                lineColor: [0, 0, 0],
            },
            headStyles: {
                fillColor: [255, 255, 255],
                textColor: [0, 0, 0],
                lineWidth: 0.1,
                lineColor: [0, 0, 0],
            },footStyles: {
                fillColor: [255, 255, 255], // Set to white to remove the background color of the footer
                textColor: [0, 0, 0], // Keep text color black
                lineWidth: 0.1, // Footer border width (same as rest of the table)
                lineColor: [0, 0, 0], // Footer border color
            },
            margin: { top: 5 },
            foot: tableFooter, 
            didDrawPage: (data) => {
                // doc.setFontSize(11);
                doc.text(`Page ${doc.internal.getNumberOfPages()}`, data.settings.margin.left, doc.internal.pageSize.height - 5);
            },
        });

        doc.save('DailyInitialFlowManagement.pdf');
    };
    // Filter data for the checksheet
    const checksheetdata = test.filter(one =>
        one.InspectionType === 'IFM - Process - Fbd' &&
        (one.DateTime.split('T')[0] === data.DateTime.split('T')[0]) &&
        one.Item === data.Item &&
        one.customFields.find(field =>
            field.FieldName === 'Shift' &&
            field.Value[0] === extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value')[0]
        )
    );

    console.log(data, "sdcssdkc", test, checksheetdata);

    // Helper function to extract data using jsonpath
    function extractData(json, path) {
        const result = jsonpath.query(json, path);
        return result;
    }

    // Function to split data into chunks of 10
    const chunkArray = (array, size) => {
        const result = [];
        for (let i = 0; i < array.length; i += size) {
            result.push(array.slice(i, i + size));
        }
        return result;
    };

    const getString = (tableData) => {
        const string = []
        data.Checksheet.forEach((one, index) => (
            tableData
                .forEach((_, idx) => {
                    if (_.Checksheet && _.Checksheet[index] && _.Checksheet[index].Data && _.Checksheet[index].Data[0] && _.Checksheet[index].Data[0].Remarks) {
                        string.push(_.Checksheet[index].Data[0].Remarks)
                    }
                })
        ))
        return string.join(', ');
    }

    // Split the checksheetdata into chunks of 10
    const chunkedChecksheetData = chunkArray(checksheetdata, 10);

    // Table rendering function
    const renderTable = (tableData, tableIndex) => (
        <>
            <button className="btn-sm btn-primary" onClick={() => downloadPdf(tableData)}>Download PDF</button>

            <div
                ref={(el) => refs.current[tableIndex] = el} // Assign a unique ref to each table container
                className="table-container" // Add a class to help with styling if needed
            >
                <table
                    className="table table-sm table-bordered table-hover small table-striped"
                    style={{ padding: 0 }}
                    key={tableIndex}
                >
                    {/* Table headers */}
                    <thead className='small text-center border'>
                        <tr className='text-center align-self-center '>
                            <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Part Name :</th>
                            <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{data.Item}</th>
                            <th style={{ verticalAlign: 'middle' }} className='fs-6' rowSpan={4} colSpan={tableData.length}> DAILY INITIAL FLOW MANAGEMENT CONTROL ITEMS MONITORING CHECKSHEET ( PROCESS )</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Part No :</th>
                            <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{data.ItemNumber}</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Model :</th>
                            <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{extractData(data, '$..customFields[?(@.FieldName=="Model")].Value')}</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>Vendor :</th>
                            <th className='text-start' style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={4}>{extractData(data, '$..customFields[?(@.FieldName=="Vendor")].Value')}</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4}>S.No</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4}>Process</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4}>Process Parameter</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4}>Spec</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4}>CHECKING METHODS </th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4}>Normal Frequency </th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={4}>IFM Frequency </th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={tableData.length + 1}>Result</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1}>Date </th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={tableData.length}>{moment(data.DateTime).format('DD-MM-YYYY')}</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1}>Shift</th>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1} colSpan={tableData.length}>{extractData(data, '$..customFields[?(@.FieldName=="Shift")].Value')}</th>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <th style={{ verticalAlign: 'middle' }} rowSpan={1}>Time </th>
                            {tableData.map((_, index) => (
                                <th style={{ verticalAlign: 'middle' }} rowSpan={1} key={index}>{moment(_.DateTime).format('HH:mm')}</th>
                            ))}
                        </tr>
                    </thead>
                    <tbody>
                        {data.Checksheet.map((one, index) => (
                            <tr key={index}>
                                <th style={{ verticalAlign: 'middle' }} className="text-center">{one.SNO}</th>
                                <th className="text-center">{one.Process}</th>
                                <th className="text-center">{one.Process_Parameter}</th>
                                <th className="text-center">{one.Spec}</th>
                                <th className="text-center">{one.Checking_Method}</th>
                                <th className="text-center">{one.Normal_Freq}</th>
                                <th className="text-center">{one.IFM_Freq}</th>
                                <th className="text-center" ></th>
                                {/* {tableData.map((_, idx) => (
                                    <th key={idx} className="text-center">{_.Checksheet[index] &&  _.Checksheet[index].StandardType=='Dimension' ? _.Checksheet[index].Data[0]&& (_.Checksheet[index].Data[0].Observed_Value + ' / '+_.Checksheet[index].Data[0].Result):_.Checksheet[index].Data[0] ? _.Checksheet[index].Data[0].Result : '-'}</th>
                                ))} */}
                                {tableData.map((_, idx) => (
                                    <th key={idx} className="text-center">{_.Checksheet[index] && _.Checksheet[index].Data[0] ? _.Checksheet[index].Data[0].Result : '-'}</th>
                                ))}
                            </tr>
                        ))}
                    </tbody>
                    <tfoot className='small text-center border'>
                        <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={7}>Note - Making is Required on first 5000 Parts or for first 3 months whichever is earlier</td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length}>
                                <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length + 6}></td>

                            </td>
                        </tr>
                        <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={7}>CHECKED BY</td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length}>{extractData(data, '$..customFields[?(@.FieldName=="Checked By")].Value')}</td>


                        </tr> <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={7}>VERIFIED BY</td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length}></td>


                        </tr> <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={7}>APPROVED</td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length}></td>


                        </tr> <tr className='text-center align-self-center '>
                            <td style={{ verticalAlign: 'middle' }} className='text-start' colSpan={7}>REMARKS</td>
                            <td style={{ verticalAlign: 'middle' }} colSpan={tableData.length}>
                                {getString(tableData)}
                            </td>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </>
    );

    return (
        <div>
               <button
  className="btn-primary btn-sm mx-1"
  onClick={() => {
    chunkedChecksheetData.forEach((tableData, index) => {
      setTimeout(() => {
        downloadPdf(tableData);
      }, index * 3000); // 3 seconds delay for each download
    });
  }}
>
  Download All 
</button>
            {/* Render tables dynamically based on chunks */}
            {chunkedChecksheetData.map((tableData, index) => (
                renderTable(tableData, index)
            ))}
        </div>
    );
};

export default DailyInitialFlowManagement_PROCESS;